import React from 'react';
import _ from 'lodash';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {API} from "aws-amplify";
import {toast} from "react-toastify";
import {Select} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import {throwGenericError} from "@/shared/transaction_state/actions";
import {requestWorkflowConversationsSuccess, TRANSACTION_KEY} from "@/shared/conversation/actions";
import InputCell from "@/common/form/InputCell";

export default function AddEditClient(props){
    var { onCancel, onSuccess, existingClient} = props;

    const [firstNameVal, setFirstNameVal] = React.useState(existingClient?.firstName || '');
    const [lastNameVal, setLastNameVal] = React.useState(existingClient?.lastName || '');
    const [emailVal, setEmailVal] = React.useState(existingClient?.email || '');
    const [phoneVal, setPhoneVal] = React.useState((existingClient && existingClient.phone) ? existingClient.phone : "");
    const [contactGroupError, setContactGroupError] = React.useState('');
    const [surveyOptOut, setSurveyOptOut] = React.useState(existingClient ? existingClient.surveyOptOut : false);
    const [allTextOptOut, setAllTextOptOut] = React.useState(existingClient ? existingClient.allTextOptOut : false);

    const hasEmail = emailVal.trim().length > 0;
    const hasPhone = phoneVal && phoneVal.length > 1;
    const isDoneEnabled = firstNameVal.trim() && lastNameVal.trim() && (hasEmail || hasPhone);

    const validateContactGroup = (currentEmail, currentPhone) => {
        const groupHasEmail = currentEmail.trim().length > 0;
        const groupHasPhone = currentPhone && currentPhone.length > 1;
        if (!groupHasEmail && !groupHasPhone) {
            setContactGroupError('Please provide at least one of Email Address or Phone Number.');
        } else {
            setContactGroupError('');
        }
    };

    const saveClient = () => {
        let updateClient = {
            firstName: firstNameVal,
            lastName: lastNameVal,
            email: emailVal,
            phone: phoneVal,
            surveyOptOut: surveyOptOut,
            allTextOptOut: allTextOptOut
        };

        if(existingClient){
            updateClient = Object.assign(existingClient, updateClient);
        }
        if(existingClient){
            API.put('Core', '/api/v1/client/' + existingClient.id, {body: updateClient})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not update user: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
        else{
            API.post('Core', '/api/v1/client', {body: updateClient})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not create user: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
    }

    const onEmailChange = (e) => {
        const val = e.target.value;
        setEmailVal(val);
        if (contactGroupError) {
            validateContactGroup(val, phoneVal);
        }
    };

    const onEmailBlur = (e) => {
        validateContactGroup(e.target.value, phoneVal);
    };

    const onPhoneChange = (phone) => {
        setPhoneVal(phone);
        if (contactGroupError) {
            validateContactGroup(emailVal, phone);
        }
    };

    const onPhoneBlur = () => {
        validateContactGroup(emailVal, phoneVal);
    };

    const toggleSurveyOptOutEnabled = () => {
        setSurveyOptOut(!surveyOptOut);
    }

    const toggleAllTextOptOutEnabled = () => {
        setAllTextOptOut(!allTextOptOut);
    }

    return (
        <div className="addEditClientForm" data-testid="addEditContactContainer">
            <div className="content">
                <div className="tableView">
                    <p style={{ marginBottom: '6px', marginTop: '0', fontSize: '0.75em', color: 'var(--colorTitle)', paddingLeft: '24px' }}>
                        Fields marked with <span style={{ color: 'red' }}>*</span> are required.
                    </p>
                    <div className="tableSection sectionName">
                        <InputCell
                            inputProps={{"data-testid": "firstName"}}
                            placeholder={"First Name"}
                            defaultValue={(existingClient ? existingClient.firstName : "")}
                            required
                            id="firstName"
                            label="First Name"
                            showRequiredIndicator
                            blurErrorMessage="First Name is required."
                            onChange={(e) => setFirstNameVal(e.target.value)}
                        />

                        <InputCell
                            inputProps={{"data-testid": "lastName"}}
                            placeholder={"Last Name"}
                            defaultValue={(existingClient ? existingClient.lastName : "")}
                            required
                            id="lastName"
                            label="Last Name"
                            name="lastName"
                            showRequiredIndicator
                            blurErrorMessage="Last Name is required."
                            onChange={(e) => setLastNameVal(e.target.value)}
                        />
                    </div>

                    <div className="tableSection sectionContact">
                        <div
                            id="contactGroupError"
                            aria-live="polite"
                            style={{ color: 'red', fontSize: '0.75em', padding: contactGroupError ? '0 0 6px 12px' : '0' }}
                        >
                            {contactGroupError}
                        </div>
                        <div onFocus={() => setContactGroupError('')}>
                            <InputCell
                                inputProps={{"data-testid": "email"}}
                                placeholder={"Email Address"}
                                defaultValue={(existingClient ? existingClient.email : "")}
                                id="email"
                                label="Email Address"
                                onChange={onEmailChange}
                                onBlur={onEmailBlur}
                            />
                        </div>

                        <div
                            className="cell inputCell phone"
                            onBlur={(e) => {
                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                    onPhoneBlur();
                                }
                            }}
                        >
                            <div className="title">Phone Number</div>
                            <PhoneInput
                                inputProps={{"data-testid": "phoneNumber"}}
                                inputClass="tel-input"
                                country={'us'}
                                onlyCountries={['us']}
                                value={phoneVal}
                                onChange={onPhoneChange}
                            />
                        </div>
                    </div>

                    <div className="tableSection sectionContact">
                        <div
                            role="switch"
                            aria-checked={surveyOptOut}
                            tabIndex="0"
                            onClick={toggleSurveyOptOutEnabled}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSurveyOptOutEnabled(); } }}
                            className={`tableCell switchCell ${surveyOptOut ? 'switchOn' : 'switchOff'}`}
                        >
                            <div className="title">Opt Out of Surveys</div>
                            <div className={`accessory accessorySwitch ${surveyOptOut ? 'on' : 'off'}`}>
                                <div className="switchThumb"/>
                            </div>
                        </div>
                        <div
                            role="switch"
                            aria-checked={allTextOptOut}
                            tabIndex="0"
                            onClick={toggleAllTextOptOutEnabled}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleAllTextOptOutEnabled(); } }}
                            className={`tableCell switchCell ${allTextOptOut ? 'switchOn' : 'switchOff'}`}
                        >
                            <div className="title">Opt Out of All Texts</div>
                            <div className={`accessory accessorySwitch ${allTextOptOut ? 'on' : 'off'}`}>
                                <div className="switchThumb"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="actionBar">
                <div className="actions">
                    <div
                        role="button"
                        tabIndex="0"
                        onClick={onCancel}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCancel(); } }}
                        className="button dismiss medium"
                    >
                        <div className="title">Cancel</div>
                    </div>

                    <div
                        data-testid="doneButton"
                        role="button"
                        tabIndex={isDoneEnabled ? 0 : -1}
                        aria-disabled={!isDoneEnabled}
                        onClick={isDoneEnabled ? saveClient : null}
                        onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && isDoneEnabled) { e.preventDefault(); saveClient(); } }}
                        className={`button confirm medium ${isDoneEnabled ? '' : 'disabled'}`}
                    >
                        <div className="title">Done</div>
                    </div>
                </div>

                <div className="separator"></div>
            </div>
        </div>
    );
}
